const DEFAULT_STATUS_COLOR = "#6B7280";

export const withHexAlpha = (hex, alphaHex = "20") => {
  if (!hex || !/^#[0-9a-f]{6}$/i.test(hex)) {
    return null;
  }
  return `${hex}${alphaHex}`;
};

export const resolveTicketStatusMeta = (statusLookup, statusValue, displayName) => {
  const candidates = [statusValue, displayName].filter(Boolean);
  for (const candidate of candidates) {
    if (statusLookup[candidate]) {
      return statusLookup[candidate];
    }
    const upper = String(candidate).toUpperCase();
    if (statusLookup[upper]) {
      return statusLookup[upper];
    }
  }

  const fallbackLabel = displayName || statusValue || "OPEN";
  return {
    label: fallbackLabel,
    colorCode: DEFAULT_STATUS_COLOR,
  };
};

const TicketStatusBadge = ({ label, colorCode = DEFAULT_STATUS_COLOR, className = "" }) => {
  const backgroundColor = withHexAlpha(colorCode, "20") || "#F3F4F6";
  const borderColor = withHexAlpha(colorCode, "40") || "#E5E7EB";

  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-md text-[11px] font-semibold uppercase tracking-wide border-0 ${className}`}
      style={{ backgroundColor, color: colorCode, borderColor }}
    >
      {label}
    </span>
  );
};

export default TicketStatusBadge;
